import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from 'src/app/shared/models/id-name.model';
import { ImageFormat } from 'src/app/shared/enums/image-formats.enum';

@Pipe({
  name: 'getImageFormat',
  standalone: false
})
export class ImageFormatPipe implements PipeTransform {
  public transform(value: ImageFormat): string {
    return getImageFormat(value);
  }
}

export function getImageFormat(value: ImageFormat): string {
  switch (value) {
    case ImageFormat.Jpg:
      return 'jpg';
    case ImageFormat.Jpeg:
      return 'jpeg';
    case ImageFormat.Png:
      return 'png';
    case ImageFormat.Gif:
      return 'gif';
    case ImageFormat.Bmp:
      return 'bmp';
    default:
      throw new Error(`Unsupported value for ImageFormat: ${value}.`);
  }
}

export function getImageFormatList(): IdName[] {
  return enumToList(ImageFormat, getImageFormat);
}
